import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function orValidator(validators: ValidatorFn[]): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const valids = validators.filter(
      (validator) => validator(control) === null
    );

    return valids.length > 0 ? null : { orValidatorError: true };
  };
}
